import { BaseEvent, BaseSystemMessage } from '../../types';

export enum ChatTriggerActionType {
  SEND_MESSAGE = 1,
  SHOW_MODAL = 2,
  SHOW_OPEN_REQUEST_MODAL = 3,
}

export type ResolveTrigger = (value: 'END_CHAT' | 'CONTINUE') => void;

export interface MatchedChatTrigger {
  report: {
    end: () => Promise<void>;
    continue: () => Promise<void>;
    openRequest: (ticketCreated: boolean) => Promise<void>;
  };
  message: string;
  triggerMessage: BaseSystemMessage | null;
  triggerEvent: BaseEvent | null;
  matchSource: ChatTriggerMatchSource | null;
  chatTriggerId: number;
  actionType: {
    id: ChatTriggerActionType;
  };
  waitForResolution(): Promise<'END_CHAT' | 'CONTINUE'>;
}

export enum ChatTriggerMatchSource {
  CATEGORY = 'CATEGORY',
  ARTICLE = 'ARTICLE',
  SECTION = 'SECTION',
}

export interface TriggerMatchListener {
  (match: MatchedChatTrigger): void;
}

export interface TriggerInterceptorOptions {
  userCountry: string;
  onMatch: TriggerMatchListener;
}
